import type { ExpressionSpecification } from "mapbox-gl";

/**
 * Fuel-load fill paint — single source of truth shared by FuelLoadLayer (the
 * 2D fill) and FuelLoad3DTrees (which swaps in the muted DIM_* variants while
 * 3D trees are on screen so the canopy reads against a quieter backdrop, and
 * restores the saturated ramp when trees are hidden).
 */
export const FUEL_FILL_COLOR: ExpressionSpecification = [
  "case",
  ["<", ["coalesce", ["get", "fuelLoad"], 0], 0.5],
  "rgba(0,0,0,0)",
  [
    "interpolate",
    ["linear"],
    ["get", "fuelLoad"],
    0.5,
    "#2e7d32",
    5,
    "#8bc34a",
    12,
    "#fff176",
    20,
    "#e53935",
    25,
    "#b71c1c",
  ],
];

export const FUEL_FILL_OPACITY: ExpressionSpecification = [
  "case",
  ["<", ["coalesce", ["get", "fuelLoad"], 0], 0.5],
  0,
  0.85,
];

export const DIM_FILL_COLOR: ExpressionSpecification = [
  "case",
  ["<", ["coalesce", ["get", "fuelLoad"], 0], 0.5],
  "rgba(0,0,0,0)",
  [
    "interpolate",
    ["linear"],
    ["get", "fuelLoad"],
    0.5,
    "#6b5f4f",
    5,
    "#7e9072",
    12,
    "#b8b394",
    20,
    "#a3766e",
    25,
    "#7d5a54",
  ],
];

export const DIM_FILL_OPACITY: ExpressionSpecification = [
  "case",
  ["<", ["coalesce", ["get", "fuelLoad"], 0], 0.5],
  0,
  0.8,
];
